import { useEffect, useState } from 'react';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { existsIndexDbToUser } from '../offlineDatabase';

export const useUserHasOfflineDatabase = () => {
  const { team } = useApplicationContext();

  const [hasIndexDb, setHasIndexDb] = useState(false);

  useEffect(() => {
    const checkIndexDb = async () => {
      const hasIndexDb = await existsIndexDbToUser();
      setHasIndexDb(hasIndexDb);
    };

    checkIndexDb();
  }, [team?.id]);

  return hasIndexDb;
};
